// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { CancellationEventArgsBase, } from "./CancellationEventArgsBase";
/**
 * Defines content of a RecognitionErrorEvent.
 * @class ConversationTranscriptionCanceledEventArgs
 */
export class ConversationTranscriptionCanceledEventArgs extends CancellationEventArgsBase {
}

//# sourceMappingURL=ConversationTranscriptionCanceledEventArgs.js.map
